import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private Procurements Types */
import {
  Settings,
  _Procurement
} from '../namespace-helper'

import _ from 'lodash'

// selected item template
const selectedProcurementTemplate = {
  id: 0,
  purchase_orders_id: 0,
  procurements_status_id: 0,
  purchase_order: {
    customers_id: 0
  }
}

export default {
  namespaced: true,
  state: {
    procurements: [],
    selectedProcurement: _.cloneDeep(selectedProcurementTemplate),
    openDialog: false,
    creatingSupplierOrders: false
  },
  mutations: {
    [_Procurement.mutations.setProcurements] (state, payload) {
      state.procurements = payload
    },
    [_Procurement.mutations.setSelectedProcurement] (state, payload) {
      if (payload !== null) {
        state.selectedProcurement = payload
      } else {
        state.selectedProcurement = _.cloneDeep(selectedProcurementTemplate)
      }
    },
    [_Procurement.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_Procurement.mutations.setCreatingSupplierOrders] (state, payload) {
      state.creatingSupplierOrders = payload
    }
  },
  actions: {
    [_Procurement.actions.saveProcurement] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/procurements'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/procurements/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_Procurement.actions.loadProcurements] (context, payload) {
      console.log('loadProcurements: ' + JSON.stringify(payload))
      console.log('loadProcurements: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/procurements?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;' +
          'purchaseOrder.purchase_orders_number:like;' +
          'purchaseOrder.customer_purchase_order_number:like;' +
          'purchaseOrder.customer.name:like;' +
          'purchaseOrder.account.firstname:like;' +
          'purchaseOrder.purchaseOrdersStatus.name:like' +
          '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedOffers: ' + JSON.stringify(r.data.data))
        context.commit(_Procurement.mutations.setProcurements, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Procurement.actions.loadProcurement] (context, payload) {
      console.log('loadProcurement: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/procurements/' + payload.id
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Procurement.actions.openCloseDialog] ({ commit }) {
      commit(_Procurement.mutations.setOpenCloseDialogState)
    },
    [_Procurement.actions.setSelectedProcurement] ({ commit }, payload) {
      commit(_Procurement.mutations.setSelectedProcurement, payload)
    },
    [_Procurement.actions.reloadSelectedPurchaseOrder] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      var url = API_URL + '/api/v1/procurements/' + payload
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_Procurement.mutations.setSelectedProcurement, r.data.data)
          resolve(r)
        }, function (err) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Procurement.actions.loadStatuses] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/procurementStatuses'

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Procurement.actions.createSupplierOrders] (context, payload) {
      context.commit(_Procurement.mutations.setCreatingSupplierOrders, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/procurements/' + payload + '/createSupplierOrders'

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_Procurement.mutations.setCreatingSupplierOrders, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_Procurement.mutations.setCreatingSupplierOrders, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Procurement.actions.resetState] ({ commit }, payload) {
      commit(_Procurement.mutations.setProcurements, [])
      commit(_Procurement.mutations.setSelectedProcurement, null)
    }
  },
  getters: {
    [_Procurement.getters.procurements] (state) {
      return state.procurements
    },
    [_Procurement.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_Procurement.getters.getSelectedProcurement] (state) {
      return state.selectedProcurement
    },
    [_Procurement.getters.creatingSupplierOrders] (state) {
      return state.creatingSupplierOrders
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Procurement/procurements.js